import { combineReducers } from 'redux'
import dashboardReducer from './DashboardReducer'
import adminDashboardReducer from './AdminDashboardReducer'
import mydocumentsReducer from './MydocumentsReducer'

import loginReducer from './LoginReducer'
import userMasterReducer from './UserMasterReducer'
import urlAuditReducer from './urlAuditReducer'
import ProfileReducer from './ProfileReducer'
import EditorReducer from './EditorReducer'
import { DESTROY_SESSION } from '../actions/LoginActions'
import trialReducer from './TrialReducer'
import CheckTrailReducer from './CheckTrailReducer'
import userManagementReducer from './UserManagementReducer'
const appReducer = combineReducers({
  //const RootReducer = combineReducers({
  login: loginReducer,
  dashboard: dashboardReducer,
  userMaster: userMasterReducer,
  urlAudit: urlAuditReducer,
  mydocuments: mydocumentsReducer,
  profile: ProfileReducer,
  editor: EditorReducer,
  trial: trialReducer,
  checkTrial: CheckTrailReducer,
  adminDashboard: adminDashboardReducer,
  userManagement: userManagementReducer,
})

//export default RootReducer

// Combine all reducers.
// const appReducer = combineReducers({
//   state: (state = {}) => state
// });
const rootReducer = (state, action) => {
  // Clear all data in redux store to initial.
  if (action.type === DESTROY_SESSION) state = undefined

  return appReducer(state, action)
}
export default rootReducer
